import { useContext } from 'react';
import { UseQueryResult, useQuery } from 'react-query';
import { DEFAULT_ERROR_MESSAGE } from '../../Base.constants';
import { ToastContext } from '../../context/ToastContext';
import { getDefaultQuestions } from '../../services/chat/getDefaultQuestions.service';
import { queryKeys } from '../queryKeyFactory';
import { useCurrentSession } from './useCurrentSession';

export const useDefaultQuestions = (): UseQueryResult<string[], Error> => {
  const toast = useContext(ToastContext);
  const { sessionId } = useCurrentSession();

  return useQuery([queryKeys.chat.getDefaultQuestions, sessionId], () => getDefaultQuestions({ sessionId }), {
    onError: () => {
      toast.error(DEFAULT_ERROR_MESSAGE);
    },
    enabled: !!sessionId,
  });
};
